import React, { Fragment } from "react";

import { t } from "i18next";

import { Box } from "@mui/material";

import VehicleSelectCard from "@/src/components/atoms/VehicleSelectCard";
import useVehicleSelectorNavigation from "@/src/components/atoms/VehicleSelectorGroup/useVehicleSelectorNavigation";
import {
  VEHICLE_TYPES,
  VEHICLE_TYPE_LABEL_KEYS
} from "@/src/components/atoms/VehicleSelectorGroup/vehicleSelector.constants";

import { VehicleType } from "@/src/types/types";

interface HomePageVehicleSelectorProps {
  vehicleType: VehicleType;
}

const rootSx = {
  display: "flex",
  width: "100%",
  minWidth: 0,
  maxWidth: "100%",
  alignItems: "stretch",
  boxSizing: "border-box"
};

const sideSpacerSx = {
  flex: { xs: "0 0 0", sm: 1 },
  display: { xs: "none", sm: "block" },
  minWidth: 0,
  alignSelf: "stretch"
};

const tabRowSx = {
  display: "flex",
  flexDirection: "row",
  alignItems: "stretch",
  justifyContent: { xs: "stretch", sm: "center" },
  width: "100%",
  maxWidth: { xs: "100%", sm: 550, md: 600 },
  minWidth: 0,
  boxSizing: "border-box"
};

const gutterSpacerSx = {
  flex: { xs: "0 0 8px", sm: "0 0 12px" },
  width: { xs: "8px", sm: "12px" },
  maxWidth: { xs: "8px", sm: "12px" },
  flexShrink: 0,
  alignSelf: "stretch",
  boxSizing: "border-box",
  display: "block"
};

const cardWrapperSx = {
  flex: 1,
  minWidth: 0,
  alignSelf: "stretch",
  display: "flex",
  flexDirection: "column"
};

const HomePageVehicleSelector = (props: HomePageVehicleSelectorProps) => {
  const { vehicleType } = props;
  const handleVehicleSelection = useVehicleSelectorNavigation("homePageView");

  return (
    <Box sx={rootSx}>
      <Box sx={sideSpacerSx} aria-hidden />
      <Box sx={tabRowSx}>
        {VEHICLE_TYPES.map((type, index) => (
          <Fragment key={type}>
            {index > 0 && <Box sx={gutterSpacerSx} aria-hidden />}
            <Box sx={cardWrapperSx}>
              <VehicleSelectCard
                vehicleType={type}
                selectedVehicleType={vehicleType}
                onVehicleTypeChange={handleVehicleSelection}
                vehicleLabel={t(VEHICLE_TYPE_LABEL_KEYS[type])}
                displayMode="homePageView"
              />
            </Box>
          </Fragment>
        ))}
      </Box>
      <Box sx={sideSpacerSx} aria-hidden />
    </Box>
  );
};

export default HomePageVehicleSelector;
